module.exports = __webpack_public_path__ + "img/nft-05.7ee88a69.jpg";